import { Inject, Injectable } from '@angular/core';
import { listContacts$ } from '@vendasta/protos/crm/v1/crmservice';
import { Observable, switchMap } from 'rxjs';
import { map } from 'rxjs/operators';
import { ACCOUNT_GROUP_TOKEN } from '../../tokens';
import { AccountGroup } from '../account-group';

@Injectable({
  providedIn: 'root',
})
export class CrmService {
  public contactIds$: Observable<string[]>;

  constructor(@Inject(ACCOUNT_GROUP_TOKEN) private readonly accountGroup$: Observable<AccountGroup>) {
    this.contactIds$ = accountGroup$.pipe(
      switchMap((accountGroup) =>
        listContacts$({
          namespace: accountGroup.accountGroupId,
          search: { searchTerm: '' },
          pagingOptions: { pageSize: 20 },
        }),
      ),
      map((resp) => resp?.crmObjects?.map((contact) => contact.crmObjectId)),
    );
  }
}
